import React from "react";

export const Navbar = () => {
  return (
    <div className="flex justify-between items-center py-5 pb-3">
      <div></div>
    </div>
  );
};
